<template lang="pug">
  .hcb-location.xs-12
    .xs-12.sm-6.sm-pr-100m
      .image-wrap.a-box-xs-8x5
        .a-box-content
          ImgBox(v-if="location.headerImage" :media-obj="location.headerImage")
          ImgBox(v-else :media-id="4949")

    .xs-12.sm-6.sm-pl-100m.location-info
      .price.bold.xs-f-xxlarge.max-at-tweak.cta-color-2.xs-pt-50m.sm-pt-0m(v-if="selectedLimitlessProPlusPrice && showPrice") ${{ selectedLimitlessProPlusPrice }}/Every 4 weeks

      .xs-f-medium.max-at-tweak
        p.bold.max-at-tweak {{ location.name }}

        span {{ location.address1 }}
        span(v-if="location.address2") &nbsp;{{ location.address2 }}
        span &nbsp;{{ location.city }}, {{ location.state }}

      a.mr-btn.full-width.xs-mt-50m.xs-mb-150m(v-if="showCta && !limitlessProPlus && !canReactivate" @click="addUrmToCart") {{ ctaText }}
      BtnBuyOrReactivateMemb.mr-btn.full-width.xs-mt-50m.xs-mb-150m(v-else-if="showCta && !limitlessProPlus && canReactivate" membership-type="limitlessProPlus")

</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import BtnBuyOrReactivateMemb from "@components/BtnBuyOrReactivateMemb";

  import ImgBox from '@components/imgBox';

  export default {
    name: 'HcbLocation',

    components: {
      ImgBox,
      BtnBuyOrReactivateMemb,
    },

    inject: ['getObjProperty'],

    props: {
      passedLocation: {
        type: Object,
        default: () => { },
      },
      showCta: {
        type: Boolean,
        default: true,
      },
      showPrice: {
        type: Boolean,
        default: true
      },
      ctaEventPrefix: {
        type: String,
        default: '',
      },
    },

    computed: {
      ...mapState('colorbar', ['location']),
      ...mapState('cart', ['cart', 'cartInitialized']),
      ...mapGetters('colorbar', ['selectedLimitlessProPlusPrice']),
      ...mapState('urm', ['urmProduct']),
      ...mapState('constants', ['limitless']),
      ...mapGetters('customer', ['limitlessProPlus', 'limitlessPlus', 'limitlessPro']),
      ...mapState('customer', ['cdata']),

      ctaText() {
        if (!this.isLimitless) {
          return "Purchase Membership";
        } else {
          return "Upgrade Membership";
        }
      },

      isLimitless() {
        return this.limitlessPlus || this.limitlessPro || this.limitlessProPlus;
      },

      membershipDetails() {
        return this.cdata?.membershipDetails ?? null;
      },

      canReactivate() {
        const membership = this.membershipDetails?.limitlessProPlus;

        return membership?.subscriptionId &&
          membership?.subscriptionLocation === this.location?.code &&
          (membership?.subscriptionStatus === 'canceled' ||
            membership?.subscriptionStatus === 'active' && membership?.pendingCancelation
          );
      },
    },

    created() {
      this.getUrmProduct();
      if (this.passedLocation) {
        this.loadLocation(this.passedLocation.code);
      }
    },

    methods: {
      ...mapActions('urm', ['getUrmProduct']),
      ...mapActions('colorbar', ['loadLocation']),
      ...mapActions('cart', ['loadCart', 'addMembershipToCart', 'setLocationId']),
      ...mapActions(['notifyError']),

      async addUrmToCart() {

        if (this.ctaEventPrefix) {
          if (this.isLimitless){
            this.trackMREvent(`${this.ctaEventPrefix} - Limitless Pro+ Upgrade Clicked`);
          } else {
            this.trackMREvent(`${this.ctaEventPrefix} - Limitless Pro+ Purchase Clicked`);
          }
        }

        const payload = {
          productId: this.urmProduct.id,
          qty: 1,
          subscription: 4,
          locationId: this.location._id,
        };

        try {
          await this.addMembershipToCart(payload);
          window.location = '/cart';
        } catch (err) {
          let errorsToNotify = {
            DUPLICATE_URM_SUBSCRIPTION: `Oops, it looks like you are already a member of ${this.limitless.PRO_PLUS}`,
          };

          let selectedErrorToNotify = errorsToNotify[this.getObjProperty(err, 'response.data.code')];

          if (selectedErrorToNotify) {
            this.notifyError(selectedErrorToNotify);
          } else {
            this.notifyError(err);
          }
        }
      },
    },
  };
</script>

<style scoped lang="stylus">
  .hcb-location
    :deep(.image-box)
      img
        border-radius 5px
</style>